(function identityTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const previousIdentityTracker = global.NewHomeSource.Analytics.identityTracker;
  const configurations = {
    hasBeenAttached: false
  };

  function inspectEvent(event) {
    const formButton = event.detail.formButton;
    const form = event.detail.form;

    if (!formButton || !formButton.dataset || !formButton.dataset.identity) {
      return;
    }

    const dataset = formButton.dataset;

    if (!form || !form.reportValidity()) {
      return;
    }

    const data = {
      caller: formButton.cloneNode(true),
      form: form.cloneNode(true)
    };

    for (let index = 0; index < configurations.totalHandlers; index += 1) {
      const handler = configurations.handlers[index].identityTracker;
      const validator = configurations.handlers[index].identityTrackerValidator;

      if (validator(dataset)) {
        configurations.queue.pushTask(handler.bind(data));
      }
    }

    if (formButton.dataset.eventForget) {
      delete formButton.dataset.event;
    }
  }

  /**
   * @constructs NewHomeSource.Analytics.IdentityTracker;
   *
   * @param {IdleQueue} eventsQueue that runs the tasks on idle periods.
   * @param {Array} handlers that will react to the impression tracking.
   */
  function IdentityTracker(eventsQueue, handlers) {
    configurations.queue = eventsQueue;
    configurations.handlers = [];

    const totalHandlers = handlers.length;

    for (let index = 0; index < totalHandlers; index += 1) {
      if (handlers[index] &&
        typeof handlers[index].identityTracker === 'function' &&
        typeof handlers[index].identityTrackerValidator === 'function') {
        configurations.handlers.push(handlers[index]);
      }
    }

    configurations.totalHandlers = configurations.handlers.length;
  }

  /**
   * @public
   * init: attaches a event listeners to the mousedown and click events.
   */
  IdentityTracker.init = function init() {
    if (configurations.hasBeenAttached) {
      return;
    }

    configurations.hasBeenAttached = true;

    document.body.addEventListener('valid-lead', inspectEvent);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Analytics.eventTracker to the previous script.
   */
  IdentityTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.identityTracker = previousIdentityTracker;
    return IdentityTracker;
  };

  global.NewHomeSource.Analytics.identityTracker = IdentityTracker;
}(window));
